import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from '../shared/utils/config.service';
import { BaseService } from '../shared/services/base.service';
import { ForgotPasswordModel } from './forgot-password.model';
import { ResetPasswordModel } from './reset-password.model';

@Injectable()
export class ForgotPasswordService extends BaseService {
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  baseUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  sendForgotPassword(model: ForgotPasswordModel): Observable<any> {
    return this.http
      .post<any>(this.baseUrl + '/UserManagement/ForgotPassword', model);
  }

  sendResetPassword(model: ResetPasswordModel): Observable<any> {
    return this.http
      .post<any>(this.baseUrl + '/UserManagement/ResetPassword', model);
  }
}
